module.exports = {
	"core": {
		"txindex": 1
	},
	"rpc": {
		"server": 1
	},
	"zeromq": {
		"zmqpubhashtx": "tcp://127.0.0.1:29000",
		"zmqpubrawblock": "tcp://127.0.0.1:29000"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Presets/lightningeclair.json
 ** module id = 41
 ** module chunks = 0
 **/